

import React from "react";
import { Modal, Box, TextField, Button, Typography } from "@mui/material";

const NotesModal = ({ open, handleClose, notes, setNotes, handleSave }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          backgroundColor: "#D6B981",
          borderRadius: "16px",
          width: { xs: "90%", sm: 500 },
          mx: "auto",
          mt: "10%",
          p: 4,
          boxShadow: 24,
        }}
      >
        <Typography
          variant="h6"
          sx={{ mb: 2, fontWeight: "bold", color: "#333" }}
        >
          Admin Notiz
        </Typography>

        <TextField
          multiline
          rows={6}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Geben Sie hier Ihre Notizen ein..."
          fullWidth
          variant="outlined"
          sx={{
            backgroundColor: "white",
            borderRadius: "8px",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#ccc",
              },
              "&:hover fieldset": {
                borderColor: "#999",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#1976d2",
              },
            },
          }}
        />

        <Box display="flex" justifyContent="flex-end" mt={3}>
          <Button
            onClick={handleClose}
            sx={{
              mr: 2,
              backgroundColor: "#ccc",
              color: "#000",
              "&:hover": {
                backgroundColor: "#b3b3b3",
              },
            }}
          >
            Abbrechen
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              backgroundColor: "#D2B885",
              color: "#000",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#c1a96c",
              },
              borderRadius: "8px",
              paddingX: 3,
              paddingY: 1,
            }}
          >
            Speichern
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default NotesModal;
